import { render, staticRenderFns } from "./ServerDelete.vue?vue&type=template&id=007787f1"
import script from "./ServerDelete.vue?vue&type=script&lang=js"
export * from "./ServerDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports